// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"09199558","25":"cd925503","340":"edfe5c2a","453":"d0c295d1","595":"e4fbedec"}[chunkId] + ".chunk.js";
};